module.exports = __webpack_public_path__ + "static/media/winter-drive.f9da02f8.jpg";